import { render, staticRenderFns } from "./baseChart.vue?vue&type=template&id=3bb99633&scoped=true"
import script from "./baseChart.vue?vue&type=script&lang=js"
export * from "./baseChart.vue?vue&type=script&lang=js"
import style0 from "./baseChart.vue?vue&type=style&index=0&id=3bb99633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb99633",
  null
  
)

export default component.exports